export const DOCUMENT_TYPE_ARTICLE_FRONTPAGE = 'article-frontpage';
